export class Pmv3MessageEventService {
  pmv3Url = null;

  constructor() {
    this.pmv3Url = process.env.REACT_APP_PMV3_ORIGIN;
  }

  initializeMessageListener(callBackFn) {
    window.addEventListener("message", (event) => {
      if (event.origin === this.pmv3Url) {
        const messageFromParent = JSON.parse(event.data);
        callBackFn?.("pmv3", messageFromParent);
      }
    });
  }
}
